import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

export const ConfirmRoleChangeDialog = ({ isOpen, onClose, onAccept, user, newRole }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{ marginBottom: "20px", padding: "32px 0 0 48px" }}
        className="white-to-dark"
      >
        Confirm role change
      </DialogTitle>
      <DialogContent sx={{ padding: "0 48px 24px" }}>
        Are you sure you want to change 
        <SoftTypography component="span" sx={{ fontWeight: 700, fontSize: "16px" }}>
          {" "}
          {user?.first_name} {user?.last_name}
        </SoftTypography>{"'s"}{" role "}
        to
        <SoftTypography component="span" sx={{ fontWeight: 700, fontSize: "16px" }}>
          {" "}
          {newRole?.label}
        </SoftTypography>
        ?
      </DialogContent>
      <DialogActions sx={{ padding: "0 48px 32px" }}>
        <SoftButton variant="outlined" color="info" onClick={onClose}>
          Cancel
        </SoftButton>
        <SoftButton color="primary" onClick={onAccept}>
          Confirm
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};
